// extracted by mini-css-extract-plugin
module.exports = {"button":"buttonDownload_button__2b8x8","icon":"buttonDownload_icon__1yVBd"};